// @internal
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { OutlineStyles, StyledSideNavProps } from '../../styles';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';
import { SideNavItemProps } from './SideNavItem';

type StyledSideNavItemLabelProps = Pick<StyledSideNavProps, 'isClosed'> & React.HTMLAttributes<HTMLSpanElement>;

export const StyledSideNavItemLabel = styled.span<StyledSideNavItemLabelProps>`
  ${({ isClosed }) =>
    isClosed &&
    css`
      display: none;
      width: 0;
    `}
`;

export const StyledSideNavNewTabIcon = styled.span`
  color: ${sidenavTokens.NewTabFontColorBaseDefault};
  font-size: ${sidenavTokens.NewTabFontSizeBaseDefault};
  font-weight: ${sidenavTokens.NewTabFontWeightBaseDefault};
`;

type StyledSideNavItemProps = Omit<SideNavItemProps, 'title' | 'url' | 'imageIcon'> &
  Pick<StyledSideNavProps, 'isClosed'>;

const SideNavItemStyles = css<StyledSideNavItemProps>`
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${sidenavTokens.FontColorBaseDefault};
  cursor: pointer;
  display: flex;
  font-size: ${sidenavTokens.ItemFontSizeBaseDefault};
  font-weight: ${sidenavTokens.GroupItemFontWeightBaseDefault};
  height: auto;
  justify-content: space-between;
  line-height: ${sidenavTokens.ItemFontLeadingBaseDefault};
  padding-bottom: ${sidenavTokens.ItemPaddingBaseOpenVertical};
  padding-left: ${sidenavTokens.ItemSpacingPaddingHorizontalBaseDefault};
  padding-right: calc(${sidenavTokens.ItemSpacingPaddingHorizontalBaseDefault} - 4px);
  padding-top: ${sidenavTokens.ItemPaddingBaseOpenVertical};
  text-align: start;
  text-decoration: none;
  transition: ${`background-color ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
        width ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}`};
  width: 100%;

  &:hover {
    background-color: ${sidenavTokens.ItemBackgroundColorActiveHover};
    text-decoration: none;
  }

  ${OutlineStyles}

  ${({ isClosed }) =>
    isClosed &&
    css`
      padding-top: calc(${sidenavTokens.ItemPaddingBaseOpenVertical} + 2px);
      padding-bottom: calc(${sidenavTokens.ItemPaddingBaseOpenVertical} + 2px);
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      border-left: ${sidenavTokens.ItemBorderWidthBaseDown} ${sidenavTokens.ItemBorderStyleBaseDefault}
        ${sidenavTokens.ItemBorderColorBaseDown};
    `}

  ${({ noStripe }) =>
    noStripe &&
    css`
      border-left-color: transparent;
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${sidenavTokens.ItemBackgroundColorActiveDefault};
      font-weight: ${sidenavTokens.GroupItemFontWeightBaseActive};
      padding-left: calc(${sidenavTokens.ItemSpacingPaddingHorizontalBaseDefault} - 4px);
    `}

  ${({ sticky }) =>
    sticky &&
    css`
      padding-top: ${sidenavTokens.ItemSpacingPaddingVerticalBaseDefault};
      padding-bottom: ${sidenavTokens.ItemSpacingPaddingVerticalBaseDefault};
    `}
`;

export const StyledSideNavItemAnchor = styled.a.withConfig<StyledSideNavItemProps>({
  shouldForwardProp: (prop, dv) => !['isClosed', 'isActive', 'imageIcon'].includes(prop) || dv(prop),
})`
  ${SideNavItemStyles}
`;
export const StyledSideNavItemLink = styled(Link).withConfig<StyledSideNavItemProps>({
  shouldForwardProp: (prop, dv) => !['isClosed', 'isActive', 'imageIcon'].includes(prop) || dv(prop),
})`
  ${SideNavItemStyles}
`;

type StyledSideNavBubbleWrapperProps = Pick<StyledSideNavProps, 'isClosed'>;

export const StyledSideNavBubbleWrapper = styled.span<StyledSideNavBubbleWrapperProps>`
  margin-left: 10px;

  ${({ isClosed }) =>
    isClosed &&
    css`
      display: none;
      width: 0;
    `}
`;
